import type { AppUser } from 'common/models';

export const isOnlyTechnician = (
  user?: Pick<AppUser, 'isTechnician' | 'isAdmin' | 'isManager' | 'isReadonly' | 'isSuperAdmin'>
) =>
  !!user?.isTechnician &&
  !user.isAdmin &&
  !user.isManager &&
  !user.isReadonly &&
  !user.isSuperAdmin;
